import React from 'react';
import { FormattedMessage } from 'react-intl';

import { emptyObject } from 'ui-components/default-props/empty';
import FormattedCurrencyContainer from '../../../../components/formatted-currency';
import ReadonlyField from './readonly-field';
import { SenderPrepay, Recipient } from '../../../../fulfillment-planner/duties-and-taxes/constants';
import { useFulfillmentDisplayContext } from '../display-context';

import { dutiesAndTaxesMessages } from '../../../../fulfillment-planner/duties-and-taxes/messages';

const dutiesAndTaxesOptions = {
  [Recipient]: 'recipientPaysOption',
  [SenderPrepay]: 'prepayDutiesOption',
};

const DutiesAndTaxes = () => {
  const {
    prepaidDutyAndPrice: { prepaidDuty = '', price = emptyObject },
  } = useFulfillmentDisplayContext();

  const ddpPrice = prepaidDuty === SenderPrepay ? <FormattedCurrencyContainer currencyCode={price?.code} value={price?.value} /> : null;

  return (
    prepaidDuty && (
      <ReadonlyField label={<FormattedMessage {...dutiesAndTaxesMessages.label} />}>
        <FormattedMessage {...dutiesAndTaxesMessages[dutiesAndTaxesOptions[prepaidDuty]]} values={{ ddpPrice }} />
      </ReadonlyField>
    )
  );
};
export { DutiesAndTaxes };
